import { AxiosRequestConfig } from 'axios'
import {
  LkPublication as Data,
  LkPublicationCollection as Collection,
} from '@/typings/api/Publication'
import {
  BaseApiParams,
  BaseApiResponse,
  BaseApiResponseCollection,
} from '@/typings/common'

import { BaseLkPublicApi } from '@/api/BaseApi'


type BR = BaseApiResponse<Data>

type BRC = BaseApiResponseCollection<never> & {
  publications: Collection[];
}

const updateMetaInResponse = (response: { count: number; meta: unknown }) => {
  if (response && 'count' in response && !response.meta) {
    // eslint-disable-next-line no-param-reassign
    response.meta = { count: response.count }
  }
  return response
}

export class LkPublicPublicationsApi extends BaseLkPublicApi<
  Data,
  Collection,
  BaseApiParams,
  BR,
  BRC
  > {
  protected readonly endpoint = 'publications';

  public setInterceptors() {
    super.setInterceptors()

    // @ts-ignore TODO:
    this.http.interceptors.response.use(updateMetaInResponse)
  }

  public getDefault(data?: Record<string, unknown>, config = {}) {
    const path = 'redirect'
    const [url, params] = this.getUrl(path, data)
    return this.request<null, Data>('GET', url, { params, ...config })
  }

  public getOneBySlug<P extends BaseApiParams>(
    slug: Data['slug'], rawParams?: P, config?: AxiosRequestConfig,
  ) {
    const path = `${slug}`
    const [url, params] = this.getUrl(path, rawParams)
    return this.request<never, Data>('GET', url, { params, ...config })
  }
}
